<p-select #dropdown [options]="restConsumedAuthenticationTypeOptions" [(ngModel)]="selectedOption" *ngIf="showDropdown"
  optionLabel="name" optionValue="value" optionDisabled="didisableFieldsabled" (onChange)="handleChange($event)"
  [autoDisplayFirst]="false" [disabled]="disabled" style="width:100%" appendTo="body">
  <ng-template let-filter pTemplate="item">
    <div [ngClass]="filter.value">
      <div>{{filter.name}}</div>
    </div>
  </ng-template>
</p-select>